define('core/linter-rules/no-http-props',["exports", "core/l10n", "core/LinterRule"], function (exports, _l10n, _LinterRule) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.rule = undefined;

  var _LinterRule2 = _interopRequireDefault(_LinterRule);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  const name = "no-http-props";

  const meta = {
    en: {
      description: "Insecure URLs are not allowed in `respecConfig`.",
      howToFix: "Please change the following properties to 'https://': "
    }
  };

  // Fall back to english, if language is missing
  const lang = _l10n.lang in meta ? _l10n.lang : "en";

  /**
   * Runs linter rule.
   *
   * @param {Object} config The ReSpec config.
   * @param  {Document} doc The document to be checked.
   */
  function lintingFunction(conf, doc) {
    // We can only really perform this check over http/https
    if (!doc.location.href.startsWith("http")) {
      return [];
    }
    const offendingMembers = Object.getOwnPropertyNames(conf)
    // this check is cheap, "prevED" is w3c exception.
    .filter(key => key.endsWith("URI") || key === "prevED")
    // this check is expensive, so separate step
    .filter(key => new URL(conf[key], doc.location.href).href.startsWith("http://")).reduce((collector, key) => collector.concat(key), []);
    if (!offendingMembers.length) {
      return [];
    }
    const result = _extends({
      name,
      occurrences: offendingMembers.length
    }, meta[lang]);
    result.howToFix += offendingMembers.map(item => "`" + item + "`").join(", ") + ".";
    return result;
  }

  const rule = exports.rule = new _LinterRule2.default(name, lintingFunction);
});
//# sourceMappingURL=no-http-props.js.map;
